import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  CardReaderDto,
  getCardReaderInfos,
  getUrl,
} from '@services/CardReadService'
import { Actions } from '@state/actions'

type Status = 'CONNECTED' | 'DISCONNECTED' | 'ERROR'
export interface ServiceInfos {
  id: string
  status: number
  statusDescription: Status
}

export const getCartVitalUrl = createAsyncThunk<CardReaderDto, void, any>(
  Actions.GET_VITAL_URL,
  async () => {
    return getUrl()
  },
)

export const doGetCardReaderInfos = createAsyncThunk<ServiceInfos>(
  'app/getCardReaderInfos',
  async (_, { rejectWithValue }) => {
    try {
      return await getCardReaderInfos()
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
